module.exports = __webpack_public_path__ + "img/RCloudService.dbdb05cd.png";